import { AdditionalInformationParsed } from './../../../apps/shoppingCart/interfaces/configuration';
import { TimeLogsComponent } from './../../../apps/timesheet/Projects/time-logs/time-logs.component';
import { CommunicationComponent } from './../../communication/communication.component';
import { NzMessageService } from 'ng-zorro-antd/message';
import { LayoutService } from './../../layout.service';
import { ModuleInformation } from './../../../models/module-information';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  HostListener,
  ComponentFactoryResolver,
  Injector,
  ViewChild,
  ViewContainerRef,
  ComponentRef,
  OnDestroy,
  TemplateRef,
} from '@angular/core';
import { Action, ActionUrl, Attachment, RecordModel } from '../../record-model';
import { RecordPageComponent } from '../record-page.component';
import * as g from 'src/app/globals';
import { RelationMapComponent } from '../../relation-map/relation-map.component';
import { tap } from 'rxjs/operators';
import { NzModalService } from 'ng-zorro-antd/modal';
import { Clipboard } from '@angular/cdk/clipboard';
import { CommunicationType } from '../../communication/communication.interface';
import { ModuleStructure } from 'src/app/models/module-structure';
import { resolve } from 'dns';
import { AvailableToPromiseComponent } from '../custom-buttons/available-to-promise/available-to-promise.component';
import { RecordChangeLogComponent } from '../custom-buttons/record-change-log/record-change-log.component';
@Component({
  selector: 'app-actions',
  templateUrl: './actions.component.html',
  styleUrls: ['./actions.component.less'],
})
export class ActionsComponent implements OnInit, OnDestroy {
  fullPath: string = '';
  files: Attachment[] = [];
  notFoundMessage = this.layoutService.translate('No attachments to display');
  downloadButtonTitle = this.layoutService.translate('Download Attachment');
  @ViewChild('attachmentsTemplate') attachmentsTemplate!: TemplateRef<any>;
  ShowDownloadButton = g.showDownloadButton;
  private actionsValue: Action[];
  get actions(): Action[] {
    return this.actionsValue;
  }
  @Input() key: any = '';
  @Input() set actions(value: Action[]) {
    this.actionsValue = value;
  }

  @Input() moduleInformation: ModuleInformation;
  @Input() recordId: any;
  @Input() recordIds: any[];
  @Input() actionType: string;
  @Input() moduleId: number;
  @Input() displayMode = 'table';
  @Input() moduleStructure: ModuleStructure;
  @Input() isTokenized: boolean;
  @Input() fromDraft: boolean;
  // for records list Cards
  @Input() inLine = false;
  // for records list table
  @Input() inList = false;
  @Input() inModuleList = false;
  @Output() backButtonClicked: EventEmitter<any> = new EventEmitter();

  @Input() thereIsResult: {
    thereIsResult: boolean;
    isError: boolean;
    errorMessage: string;
  } = { thereIsResult: false, isError: false, errorMessage: '' };

  @Output() thereIsResultChange: EventEmitter<{
    thereIsResult: boolean;
    isError: boolean;
    errorMessage: string;
  }> = new EventEmitter();
  @ViewChild('extraComponent', { read: ViewContainerRef })
  extraComponentRef: ViewContainerRef;
  groupedActions: { key: string; actions: Action[] }[] = [];
  ungroupedActions: Action[] = [];
  isTokenModalVisible = false;
  tokenLink = '';
  loading = true;
  innerWidth: number;
  actionsExpanded = false;
  removeActionText = false;
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.innerWidth = window.innerWidth;
  }
  componentRef: ComponentRef<TimeLogsComponent>;
  constructor(
    private drawerService: NzDrawerService,
    private router: Router,
    private httpClient: HttpClient,
    private layoutService: LayoutService,
    private modal: NzModalService,
    private clipboard: Clipboard,
    private message: NzMessageService,
    private componentFactoryResolver: ComponentFactoryResolver,
    private injector: Injector,
  ) {
    this.innerWidth = window.innerWidth;
  }
  ngOnDestroy(): void {
    if (this.componentRef != null) {
      this.componentRef.destroy();
    }
  }

  ngOnInit(): void {
    this.layoutService.screenSizeEmitter.subscribe();
    if (this.moduleInformation == null) {
      this.layoutService
        .moduleInformation(this.moduleId.toString())
        .pipe(
          tap((information: ModuleInformation) => {
            this.moduleInformation = information;
            this.prepareActions();
          }),
        )
        .subscribe();
    } else {
      this.prepareActions();
    }

    var modulesToCheck = g.removeActionTextForModules.split(',');
    if (
      modulesToCheck.indexOf(this.moduleStructure.module.Id.toString()) !== -1
    ) {
      this.removeActionText = true;
    }
  }

  prepareActions() {
    if (this.moduleId == null || this.moduleStructure === undefined) {
      return;
    }
    if (this.actions == null || this.actions.length === 0) {
      this.layoutService.getActions(this.moduleId).subscribe((d) => {
        this.actions = d;
        this.prepareActionGroups();
      });
    } else {
      this.prepareActionGroups();
    }
    this.actionsExpanded =
      this.moduleStructure.module.AdditionalInformationParsed.ActionsExpanded;
  }

  prepareActionGroups() {
    this.ungroupedActions = this.actions.filter(
      (d) =>
        (d.GroupName === '' || d.GroupName == null) &&
        (d.AdditionalInformationParsed === undefined ||
          d.AdditionalInformationParsed.ForDraftDocument === undefined ||
          this.fromDraft === d.AdditionalInformationParsed.ForDraftDocument),
    );

    if (
      this.moduleInformation.AuthorisedForCreate === true &&
      !this.fromDraft &&
      this.moduleStructure?.module.AdditionalInformationParsed
        .ShowDuplicateButton &&
      this.moduleStructure?.module.TableName !== 'ODRF'
      /* && this.moduleId !== 2 */
    ) {
      this.ungroupedActions.push({
        Name: this.layoutService.translate('Duplicate'),
        ActionUrls: [
          {
            Class: '',
            ConfirmationMessage: '',
            Icon: '',
            Multiple: false,
            ShowConfirmation: false,
            Target: 'ajax',
            Text: '',
            Url: `{"url":"/apps/crm/module-list/${this.moduleId}","params":{"ModuleActionType":2,"SourceModuleId":${this.moduleId},"ModuleId":${this.moduleId},"selectedId":"ID_TO_REPLACE"}}`,
            UrlTemplate: `{"RecordPage":"{"url":"/apps/crm/module-list/${this.moduleId}","params":{"ModuleActionType":2,"SourceModuleId":${this.moduleId},"ModuleId":${this.moduleId},"selectedId":"ID_TO_REPLACE"}}"}`,
          },
        ],
        //Areas: [1, 2],
        FieldDescription: 'Duplicate',
        Icon: '',
        Id: 1000000,
        ModuleName: '',
        ObjectId: '',
        //RecordDescription: '',
        SortOrder: 100,
        Url: '',
      });
    }

    const groupsUndistinct = this.actions
      .filter(
        (t) =>
          t.GroupName !== '' &&
          t.GroupName != null &&
          (t.AdditionalInformationParsed === undefined ||
            t.AdditionalInformationParsed.ForDraftDocument === undefined ||
            this.fromDraft === t.AdditionalInformationParsed.ForDraftDocument),
      )
      .map((y) => y.GroupName);

    const groups = [];
    groupsUndistinct.forEach((group) => {
      const temp = groups.filter((z) => z === group);
      if (temp.length === 0) {
        groups.push(group);
      }
    });

    groups.forEach((group) => {
      this.groupedActions.push({
        key: group,
        actions: this.actions.filter((v: any) => v.GroupName === group),
      });
    });

    if (this.inLine) {
      this.groupedActions = JSON.parse(JSON.stringify(this.groupedActions));
      this.ungroupedActions = JSON.parse(JSON.stringify(this.ungroupedActions));

      this.groupedActions.forEach((actionGroup) => {
        actionGroup.actions.forEach((action) => {
          action.ActionUrls = action.ActionUrls.filter(
            (actionUrl) => actionUrl.Multiple,
          );
        });

        actionGroup.actions = actionGroup.actions.filter(
          (action) => action.ActionUrls.length > 0,
        );
      });

      this.groupedActions = this.groupedActions.filter(
        (actionGroup) => actionGroup.actions.length > 0,
      );

      //
      this.ungroupedActions.forEach((action) => {
        action.ActionUrls = action.ActionUrls.filter(
          (actionUrl) => actionUrl.Multiple,
        );
      });

      this.ungroupedActions = this.ungroupedActions.filter(
        (action) => action.ActionUrls.length > 0,
      );
    }

    this.loading = false;
  }

  linkedObjectSubmitted(result, args) {
    console.log(args, result);
    RecordPageComponent.openRecordPage(this.drawerService, {
      moduleId: args.moduleId,
      actionType: 'Edit',
      drawerTitle: args.drawerTitle,
      inDrawer: true,
      parentComponent: args.parentComponent,
      recordId: result,
      recordModel: undefined,
    });
  }

  executeAction(url: ActionUrl) {
    if (url.ShowConfirmation) {
      this.modal.confirm({
        nzTitle: url.ConfirmationMessage,
        nzOnOk: () => this.executeActionAfterConfirmation(url),
      });
    } else {
      this.executeActionAfterConfirmation(url);
    }
  }

  private executeActionAfterConfirmation(url: ActionUrl) {
    let selectedId = this.recordId;
    let selectedIdForJson = this.recordId;
    let isMultiLines = false;
    if (this.inLine) {
      selectedId = '';
      this.recordIds.forEach((recordId) => {
        if (recordId == null || recordId === 'undefined') {
          return;
        }
        isMultiLines = true;
        selectedId += recordId + ',';
        selectedIdForJson += recordId + ',';
      });

      selectedId = selectedId.slice(0, -1);
    }

    if (url.UrlTemplate.indexOf('RecordPage') !== -1) {
      const urlToOpen = url.Url.replace('ID_TO_REPLACE', selectedIdForJson);
      const urlObj = JSON.parse(urlToOpen);

      const moduleActionType = urlObj.params.ModuleActionType;
      /*if (moduleActionType == 17) {
      }*/

      if (
        this.inModuleList &&
        url.UrlTemplate.indexOf('RecordPageDrawer') == -1
      ) {
        let inputValue = '';
        if (urlObj.params.InputLabel) {
          const inputLabel = urlObj.params.InputLabel;
          if (inputLabel) {
            inputValue = '_' + prompt(inputLabel);
          }
          if (inputValue.trim() === '_' || inputValue.trim() === '_null') {
            alert('You must provide a value for the input field to proceed');
            return;
          }
        }

        let baseUrl = this.router.url.split(';')[0];
        var indexOfModuleList = baseUrl.indexOf('module-list');
        baseUrl = baseUrl.substring(0, indexOfModuleList);
        baseUrl = `${baseUrl}/module-list/${urlObj.params.ModuleId}/0`;

        this.router.navigate([
          baseUrl,
          {
            fromDraft: false,
            newMode: true,
            actionType: urlObj.params.ModuleActionType,
            moduleActionType: urlObj.params.ModuleActionType,
            sourceObject: urlObj.params.SourceModuleId,
            sourceObjectId: selectedId,
            customActionCode: urlObj.params.CustomActionCode + inputValue,
            inDrawer: false,
          },
        ]);
      } else {
        let inputValue = '';
        if (urlObj.params.InputLabel) {
          const inputLabel = urlObj.params.InputLabel;
          if (inputLabel) {
            inputValue = '_' + prompt(inputLabel);
          }
          if (inputValue.trim() === '_' || inputValue.trim() === '_null') {
            alert('You must provide a value for the input field to proceed');
            return;
          }
        }

        this.layoutService
          .moduleInformation(urlObj.params.ModuleId)
          .subscribe((moduleStructure: ModuleInformation) => {
            RecordPageComponent.openRecordPage(this.drawerService, {
              actionType: 'Add',
              //drawerTitle: this.layoutService.translate(`Execute Action`),
              drawerTitle: this.layoutService.translate(
                moduleStructure.CreateNewText,
              ),
              inDrawer: true,
              moduleId: urlObj.params.ModuleId,
              moduleActionType: urlObj.params.ModuleActionType,
              sourceModuleId: urlObj.params.SourceModuleId,
              parentComponent: this,
              recordId: undefined,
              sourceRecordId: selectedId,
              customActionCode: urlObj.params.CustomActionCode + inputValue,
              recordModel: undefined,
            });
          });
      }
    } else if (url.UrlTemplate.indexOf('EmailDocument') !== -1) {
      if (this.inList || this.inLine) {
        console.log(this.recordIds);
        if (this.moduleStructure == null) {
          this.layoutService
            .getModuleStructure(this.moduleId)
            .subscribe((moduleStructure) => {
              this.moduleStructure = moduleStructure;
              this.EmailDocument(url);
            });
        } else {
          this.EmailDocument(url);
        }
      }
    } else if (url.UrlTemplate.indexOf('ngFullUrl') !== -1) {
      const urlToOpen = url.Url.replace('ID_TO_REPLACE', selectedIdForJson);

      const urlObj = JSON.parse(urlToOpen);
      this.router.navigate([urlObj.url, urlObj.params]);
    } else if (url.UrlTemplate.indexOf('PaymentPage') !== -1) {
      const urlToOpen = url.Url.replace(
        'MODULE_ID',
        this.moduleId.toString(),
      ).replace('RECORD_ID', selectedIdForJson);
      const urlObj = JSON.parse(urlToOpen);
      this.router.navigate([urlObj.url], { queryParams: urlObj.params });
    } else if (url.UrlTemplate.indexOf('RelationMap') !== -1) {
      this.openRelationComponent();
    } else if (url.UrlTemplate.indexOf('ChangeLog') !== -1) {
      this.openChangeLogComponent();
    } else if (url.UrlTemplate.indexOf('ATP_REPORT') !== -1) {
      this.openAvailableToPromiseComponent();
    } else if (url.UrlTemplate.indexOf('ExecuteCustomAction') !== -1) {
      const urlObj = JSON.parse(url.UrlTemplate);
      if (
        urlObj.isHTML === 'true' ||
        urlObj.isHTML === true ||
        urlObj.isMessage === true
      ) {
        let urlToOpen = url.Url.replace('ID_TO_REPLACE', selectedId);
        urlToOpen = `${g.baseUrl}${urlToOpen}&${g.getUrlSuffix()}`;

        this.httpClient.get(urlToOpen).subscribe((d: any) => {
          if (urlObj.isMessage) {
            const resultValue = JSON.parse(d.Resault_Value);
            if (resultValue.Has_Error) {
              this.modal.error({
                nzContent: resultValue.Error_Message,
              });
            } else {
              if (
                resultValue.Resault_Value == null ||
                resultValue.Resault_Value === ''
              ) {
                this.modal.success({
                  nzContent: resultValue.Message,
                  nzCloseOnNavigation: true,
                });
              } else {
                this.modal.success({
                  nzContent: resultValue.Message,
                  nzCloseOnNavigation: true,
                  nzOkText: resultValue.OkText,
                  nzOnOk: () => {
                    window.open(
                      g.apiBaseUrl +
                        resultValue.Resault_Value +
                        '&' +
                        g.getUrlSuffix(),
                    );
                  },
                });
              }
            }
          } else {
            this.modal.info({
              nzContent: d,
            });
          }
        });
      } else {
        let urlToOpen = url.Url.replace('ID_TO_REPLACE', selectedId);
        if (url.Url.indexOf('MODULE_ID') !== -1) {
          urlToOpen = urlToOpen.replace('MODULE_ID', this.moduleId.toString());
        }
        // if (url.Url.indexOf('OBJECT_TYPE') !== -1) {
        //   urlToOpen = urlToOpen.replace('OBJECT_TYPE');
        // }
        if (url.Target === '_self') {
          const urlToLuanch = `${g.baseUrl}${urlToOpen}&${g.getUrlSuffix()}`;
          this.httpClient.get(urlToLuanch).subscribe((d: any) => {
            console.log('remove', d);
            this.thereIsResult.isError = d.Has_Error;
            this.thereIsResult.errorMessage = d.Error_Message;
            this.thereIsResult.thereIsResult = true;

            if (this.thereIsResult.isError) {
              this.modal.error({
                nzContent: this.thereIsResult.errorMessage,
              });
            } else {
              this.modal.success({
                nzContent: this.layoutService.translate(
                  'Your operation has been completed successfully!',
                ),
              });
            }

            this.thereIsResultChange.emit(this.thereIsResult);
            if (!this.thereIsResult.isError) {
              this.backButtonClicked.emit();
              this.layoutService.refreshListEmitter.emit();
            }
          });
        } else {
          window.open(`${g.baseUrl}${urlToOpen}&${g.getUrlSuffix()}`);
        }
      }
    } else if (url.UrlTemplate.indexOf('ExecuteMethodOfModule') !== -1) {
      const urlToOpen = url.Url.replace('ID_TO_REPLACE', selectedId);
      const urlToLuanch = `${g.baseUrl}${urlToOpen}&${g.getUrlSuffix()}`;
      this.httpClient.get(urlToLuanch).subscribe((d: any) => {
        console.log('remove', d);
        this.thereIsResult.isError = d.Has_Error;
        this.thereIsResult.errorMessage = d.Error_Message;
        this.thereIsResult.thereIsResult = true;

        this.thereIsResultChange.emit(this.thereIsResult);
        if (!this.thereIsResult.isError) {
          let content = '';
          const result = d.Resault_Value as any[];
          result.forEach((r) => {
            if (r.Has_Error) {
              content +=
                '<br />' +
                r.Resault_Value +
                ' - ' +
                this.layoutService.translate('error') +
                ' - ' +
                r.Error_Message;
            } else {
              content +=
                '<br />' +
                r.Resault_Value +
                ' - ' +
                this.layoutService.translate(
                  'Operation completed successfully',
                );

              this.layoutService.refreshListEmitter.emit();
            }
          });

          this.modal.info({
            nzContent: content,
          });
        }
      });
    } else if (url.Url.indexOf('PM_APPROVE') != -1) {
      this.loadTimesLogComponent('PM_APPROVE');
    } else if (url.Url.indexOf('CUSTOMER_APPROVE') != -1) {
      this.loadTimesLogComponent('CUSTOMER_APPROVE');
    } else {
      const urlToOpen = url.Url.replace('ID_TO_REPLACE', selectedId);

      if (url.Target === '_self' && !isMultiLines) {
        const urlToLuanch = `${g.baseUrl}${urlToOpen}&${g.getUrlSuffix()}`;
        this.httpClient.get(urlToLuanch).subscribe((d: any) => {
          console.log('remove', d);
          this.thereIsResult.isError = d.Has_Error;
          this.thereIsResult.errorMessage = d.Error_Message;
          this.thereIsResult.thereIsResult = true;

          this.thereIsResultChange.emit(this.thereIsResult);
          if (!this.thereIsResult.isError) {
            this.backButtonClicked.emit();
          }
        });
      } else if (url.Class === 'generate-link' && !isMultiLines) {
        let urlToLuanch = `${g.baseUrl}${urlToOpen}&${g.getUrlSuffix()}`;
        urlToLuanch = urlToLuanch
          .replace('MODULE_ID', this.moduleId.toString())
          .replace('API', 'TOKENIZ');
        this.httpClient.get(urlToLuanch).subscribe((x: any) => {
          const BaseUrl = x.Resault_Value.AngularBaseUrl;
          const Token = x.Resault_Value.Token;
          this.tokenLink = `${BaseUrl}apps/documents/index?token=${Token}&App=ITM-TOKENIZ&language=${g.language}`;
          this.isTokenModalVisible = true;
        });
      } else {
        window.open(`${g.baseUrl}${urlToOpen}&${g.getUrlSuffix()}`);
      }
    }
  }

  openRelationComponent(): void {
    const drawerRef = this.drawerService.create<
      RelationMapComponent,
      { moduleId: number; recordId: any },
      string
    >({
      nzTitle: this.layoutService.translate('Relationship Map'),
      nzContent: RelationMapComponent,
      nzWrapClassName: 'drawer-size-4x',
      nzContentParams: {
        moduleId: this.moduleId,
        recordId: this.recordId,
      },
    });
  }

  openChangeLogComponent(): void {
    const drawerRef = this.drawerService.create({
      nzContent: RecordChangeLogComponent,
      nzWrapClassName: 'drawer-size-3x',
      nzTitle: 'Change Log...',
      nzContentParams: {
        //cardCode: cardCode,
        DocEntry: this.recordId,
        DocType: this.moduleStructure.module.ObjectTypeValue,
        moduleId: this.moduleId,
      },
    });
  }

  openAvailableToPromiseComponent(): void {
    const drawerRef = this.drawerService.create({
      nzContent: AvailableToPromiseComponent,
      nzWrapClassName: 'drawer-size-3x',
      nzTitle: 'Available to promise',
      nzContentParams: {
        //cardCode: cardCode,
        itemCode: this.recordId,
        warehouse: g.defaultWarehouseInATP,
      },
    });
  }

  copyTokenLink() {
    this.clipboard.copy(this.tokenLink);
    this.message.info('Link copied to the clipboard');
  }
  EmailDocument(url) {
    const objectCode = this.moduleStructure.module.ObjectTypeValue;
    const recordModel: RecordModel = new RecordModel();
    recordModel.ObjectCode = objectCode;
    const urlObj = JSON.parse(url.Url);
    const layoutId = urlObj.print;
    console.log('layoutId', layoutId);
    const drawerRef = this.drawerService.create({
      nzTitle: this.layoutService.translate(`Email Documents`),
      nzContent: CommunicationComponent,
      nzWrapClassName: 'drawer-size-4x',
      nzContentParams: {
        gotoTab: CommunicationType.Email,
        moduleId: this.moduleId,
        recordId: this.recordIds.join(','),
        recordModel,
        layoutId,
        multiDoc: true,
      },
    });
  }
  async loadTimesLogComponent(approvalType: string) {
    await new Promise((resolve) => {
      this.extraComponentRef.clear();
      const fact =
        this.componentFactoryResolver.resolveComponentFactory(
          TimeLogsComponent,
        );
      this.componentRef = this.extraComponentRef.createComponent(fact);
      resolve(null);
    });
    if (approvalType === 'CUSTOMER_APPROVE') {
      this.componentRef.instance.approvalType = 'CUSTOMER_APPROVE';
      this.componentRef.instance.CustomerApprove(this.recordId);
    } else if (approvalType === 'PM_APPROVE') {
      this.componentRef.instance.approvalType = 'PM_APPROVE';
      this.componentRef.instance.PMApprove(this.recordId);
    }
    this.componentRef.instance.moduleStructure = this.moduleStructure;
  }

  showAttachment(): void {
    const ref = this.modal.create({
      nzTitle: this.layoutService.translate('Attachment Details'),
      nzContent: this.attachmentsTemplate,
      nzFooter: null,
      nzMaskClosable: true,
      nzClosable: true,
      nzWidth: 650,
    });
  }
  download() {
    const queryId = g.getQueryId('DownloadFilesQueryId');
    if (!queryId) return;

    this.layoutService
      .executeQuery(queryId, { ObjectKey: this.key })
      .subscribe({
        next: (data: any[]) => {
          this.files = data;
          this.showAttachment();
        },
      });
  }
  previewFile(filePath: string) {
    this.fullPath = filePath;
    const safePath = filePath.split('#').join('_HASH_');
    window.open(
      g.apiBaseUrl +
        'media/previewfile?path=' +
        encodeURIComponent(safePath) +
        '&' +
        g.getUrlSuffix(),
    );
  }
}
